import React from 'react';
import { Trans } from 'react-i18next';
import { ColumnsType } from 'common/components/antd/Table/Table';
import { renderCopyableCell } from 'common/components/CopyableCell/CopyableCell';
import { alphabeticSortFn, numericSortFn } from 'common/utils/sort.utils';
import { ECounterpartiesTableColumns } from './counterparties-table.enum';
import { TCounterpartyTableRecord } from './counterparties-table.types';

type TGetCounterpartiesColumnsProps = {
  formatNumber: (number: number) => string;
};

export const getColumns = ({
  formatNumber,
}: TGetCounterpartiesColumnsProps): ColumnsType<TCounterpartyTableRecord> => [
  {
    title: <Trans i18nKey="dashboard.counterpartiesTable.column.counterpartyName" />,
    dataIndex: ECounterpartiesTableColumns.Name,
    key: ECounterpartiesTableColumns.Name,
    width: 236,
    sorter: alphabeticSortFn(ECounterpartiesTableColumns.Name),
    searchable: true,
  },
  {
    title: <Trans i18nKey="dashboard.counterpartiesTable.column.reserveAcc" />,
    dataIndex: ECounterpartiesTableColumns.ReserveAcc,
    key: ECounterpartiesTableColumns.ReserveAcc,
    width: 191,
    render: (text) => renderCopyableCell(formatNumber(text)),
    sorter: numericSortFn(ECounterpartiesTableColumns.ReserveAcc),
  },
  {
    title: <Trans i18nKey="dashboard.counterpartiesTable.column.emissionAcc" />,
    dataIndex: ECounterpartiesTableColumns.EmissionAcc,
    key: ECounterpartiesTableColumns.EmissionAcc,
    width: 191,
    render: (text) => renderCopyableCell(formatNumber(text)),
    sorter: numericSortFn(ECounterpartiesTableColumns.EmissionAcc),
  },
  {
    title: <Trans i18nKey="dashboard.counterpartiesTable.column.processingAcc" />,
    dataIndex: ECounterpartiesTableColumns.ProcessingAcc,
    key: ECounterpartiesTableColumns.ProcessingAcc,
    width: 190,
    render: (text) => renderCopyableCell(formatNumber(text)),
    sorter: numericSortFn(ECounterpartiesTableColumns.ProcessingAcc),
  },
  {
    title: <Trans i18nKey="dashboard.counterpartiesTable.column.totalAmount" />,
    dataIndex: ECounterpartiesTableColumns.TotalAmount,
    key: ECounterpartiesTableColumns.TotalAmount,
    width: 188,
    render: (text) => renderCopyableCell(formatNumber(text)),
    sorter: numericSortFn(ECounterpartiesTableColumns.TotalAmount),
  },
  {
    title: <Trans i18nKey="dashboard.counterpartiesTable.column.issue" />,
    dataIndex: ECounterpartiesTableColumns.Issue,
    key: ECounterpartiesTableColumns.Issue,
    width: 190,
    render: (text) => renderCopyableCell(formatNumber(text)),
    sorter: numericSortFn(ECounterpartiesTableColumns.Issue),
  },
  {
    title: <Trans i18nKey="dashboard.counterpartiesTable.column.burn" />,
    dataIndex: ECounterpartiesTableColumns.Burn,
    key: ECounterpartiesTableColumns.Burn,
    width: 190,
    render: (text) => renderCopyableCell(formatNumber(text)),
    sorter: numericSortFn(ECounterpartiesTableColumns.Burn),
  },
];
